import { render, staticRenderFns } from "./OrderSummaryModal.vue?vue&type=template&id=1ca8644b&scoped=true&"
import script from "./OrderSummaryModal.vue?vue&type=script&lang=js&"
export * from "./OrderSummaryModal.vue?vue&type=script&lang=js&"
import style0 from "./OrderSummaryModal.vue?vue&type=style&index=0&id=1ca8644b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ca8644b",
  null
  
)

export default component.exports